module.exports = __webpack_public_path__ + "img/banklogo1.29721242.png";